import React, { useState } from "react";
import DashboardHeader from "../components/DashboardHeader"; 
import { PlusCircle, Send, AlertCircle, CheckCircle } from "lucide-react";

export default function CreareProiect({ memberData }) {
  const [titlu, setTitlu] = useState("");
  const [descriereScurta, setDescriereScurta] = useState("");
  const [descriereLunga, setDescriereLunga] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (!titlu.trim()) return setError("Completează titlul proiectului.");
    if (!descriereScurta.trim()) return setError("Completează o descriere scurtă.");

    setLoading(true);
    try {
      const payload = {
        id_membru_initiaza: memberData.id,
        descriere_scurta: descriereScurta,
        descriere_lunga: descriereLunga.trim() ? descriereLunga : null,
        titlu: titlu,
      };

      const res = await fetch("https://prdp-api.suport-949.workers.dev/api/proiecte", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer unwantedtok",
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Proiectul nu a putut fi creat!");
      setSuccessMsg("Proiectul a fost creat și trimis spre aprobare Biroului Național.");
      setTitlu("");
      setDescriereScurta("");
      setDescriereLunga("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="dashboard-wrapper" style={{ overflowX: "hidden", minHeight: "100vh", backgroundColor: "#0b1120", paddingBottom: "60px" }}>
      <DashboardHeader user={memberData} />
      
      <style>{`
        .premium-input:focus {
          border-color: #fbbf24 !important;
          box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.2) !important;
        }
      `}</style>

      <div style={{ 
        maxWidth: "650px", 
        margin: "40px auto", 
        backgroundColor: "#1e293b", 
        padding: "40px", 
        borderRadius: "24px", 
        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
        border: "1px solid rgba(255, 255, 255, 0.05)"
      }}>
        <h4 style={{ color: "#f8fafc", fontWeight: 800, marginBottom: "12px", fontSize: "1.75rem", display: "flex", alignItems: "center", gap: "10px" }}>
          <PlusCircle color="#fbbf24" size={28} /> Propune un proiect
        </h4>
        <div style={{ color: "#94a3b8", marginBottom: "32px", fontSize: "1rem", lineHeight: "1.5" }}>
          Completează formularul de mai jos pentru a iniția un proiect nou. După aprobarea din partea Biroului Național, acesta va fi supus la vot pentru toți membrii PRDP.
        </div>
        
        {error && (
          <div style={{ backgroundColor: "rgba(239, 68, 68, 0.1)", color: "#ef4444", padding: "16px", borderRadius: "12px", marginBottom: "24px", display: "flex", alignItems: "center", gap: "10px", fontWeight: "500" }}>
            <AlertCircle size={20} /> {error}
          </div>
        )}
        
        {successMsg && (
          <div style={{ backgroundColor: "rgba(16, 185, 129, 0.1)", color: "#10b981", padding: "16px", borderRadius: "12px", marginBottom: "24px", display: "flex", alignItems: "center", gap: "10px", fontWeight: "500" }}>
            <CheckCircle size={20} /> {successMsg}
          </div>
        )}
        
        <form onSubmit={handleSubmit} autoComplete="off" style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <div>
            <label style={{ color: "#cbd5e1", fontSize: "0.85rem", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", marginBottom: "8px", display: "block" }}>
              Titlu proiect
            </label>
            <input
              className="premium-input"
              type="text"
              value={titlu}
              placeholder="Ex: Parc modern în cartierul X"
              onChange={e => setTitlu(e.target.value)}
              required
              style={{
                width: "100%", padding: "14px 18px", borderRadius: "12px", border: "1px solid rgba(255, 255, 255, 0.1)",
                backgroundColor: "#0f172a", color: "#f8fafc", fontSize: "1rem", outline: "none", transition: "all 0.2s ease"
              }}
            />
          </div>

          <div>
            <label style={{ color: "#cbd5e1", fontSize: "0.85rem", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", marginBottom: "8px", display: "block" }}>
              Descriere scurtă (Pitch)
            </label>
            <input
              className="premium-input"
              type="text"
              value={descriereScurta}
              placeholder="O frază convingătoare despre proiect..."
              onChange={e => setDescriereScurta(e.target.value)}
              required
              style={{
                width: "100%", padding: "14px 18px", borderRadius: "12px", border: "1px solid rgba(255, 255, 255, 0.1)",
                backgroundColor: "#0f172a", color: "#f8fafc", fontSize: "1rem", outline: "none", transition: "all 0.2s ease"
              }}
            />
          </div>

          <div>
            <label style={{ color: "#cbd5e1", fontSize: "0.85rem", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", marginBottom: "8px", display: "block" }}>
              Descriere detaliată (Argumentare - Opțional)
            </label>
            <textarea
              className="premium-input"
              value={descriereLunga}
              rows={5}
              placeholder="Argumentează de ce este important acest proiect, care sunt beneficiarii..."
              onChange={e => setDescriereLunga(e.target.value)}
              style={{
                width: "100%", padding: "14px 18px", borderRadius: "12px", border: "1px solid rgba(255, 255, 255, 0.1)",
                backgroundColor: "#0f172a", color: "#f8fafc", fontSize: "1rem", outline: "none", transition: "all 0.2s ease", resize: "vertical"
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: "12px",
              padding: "16px 24px",
              fontSize: "1.05rem",
              fontWeight: 700,
              borderRadius: "14px",
              border: "none",
              cursor: loading ? "not-allowed" : "pointer",
              backgroundColor: loading ? "#475569" : "#fbbf24",
              color: loading ? "#94a3b8" : "#0f172a",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              transition: "all 0.2s ease"
            }}
            onMouseEnter={(e) => {
              if (!loading) e.currentTarget.style.backgroundColor = "#f59e0b";
            }}
            onMouseLeave={(e) => {
              if (!loading) e.currentTarget.style.backgroundColor = "#fbbf24";
            }}
          >
            {loading ? "Se trimite cererea..." : <><Send size={20} /> Propune proiectul</>}
          </button>
        </form>
      </div>
    </div>
  );
}
